import React from 'react';


var TransferWarningDependenciesPopup = React.createClass({
  handleStopPropogation: function(e) {
    e.stopPropagation();
  },
  handleCloseClick: function(){
    this.props.transferWarningDependencies("close");
  },
  render: function() {
    return (
      <div className="modal__mask" onClick = {this.handleCloseClick}> 
      <div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
        <div className="modal__header">
          <h3 className="modal__header--title">Warning: Private 3rd Party Dependencies</h3>
          <a href="javascript:void(0)" className="modal__close"><i className="fa  fa-close"> </i></a> </div>
        <div className="modal__body clearfix">
          <div className="form__row clearfix">
            <p>Package <strong>Corporate Attorney Theme</strong> depends on 3rd party packages, that your  transferee, <a href="#">legutierr</a>, does not have access to.</p>
          </div>
          <div className="form__row clearfix">
            <div className="form__cell">
              <ul className="list-unstyled prod-list">
                <li className="prod-list__item">
                  <div className="prod-list__cell prod-list__cell--media">             
                    <a href="javascript:void(0)" className="prod-list__cell--media__link tooltip__container">

                      <img src="images/prod_thumb.jpg" align="" title="" className="prod-list__cell--media__img" />
                      <span className="tooltip tooltip--right tooltip--md prod-list__cell--media__tooltip"> 
                        <img src="images/prod_thumb_lg.png" align="" title="" className="img--responsive prod-list__cell--media__thumb" />
                      </span>

                    </a>
                  </div>
                  <div className="prod-list__cell prod-list__cell--desc"> 
                    <h5 className="prod-list__cell--title text_color--bold">Special Testimonial Layout </h5>
                    <p className="prod-list__cell--copy">by: 3rdPartyUser</p>
                  </div>
                </li>

                <li className="prod-list__item">
                  <div className="prod-list__cell prod-list__cell--media">             
                    <a href="#" className="prod-list__cell--media__link tooltip__container">

                      <img src="images/prod_thumb.jpg" align="" title="" className="prod-list__cell--media__img" />
                      <span className="tooltip tooltip--right tooltip--md prod-list__cell--media__tooltip"> 
                        <img src="images/prod_thumb_lg.png" align="" title="" className="img--responsive prod-list__cell--media__thumb" />
                      </span>

                    </a>
                  </div>
                  <div className="prod-list__cell prod-list__cell--desc"> 
                    <h5 className="prod-list__cell--title text_color--bold">Special Testimonial Layout </h5>
                    <p className="prod-list__cell--copy">by: ThirdPartyUser</p>
                  </div>
                </li>

                <li className="prod-list__item">
                  <div className="prod-list__cell prod-list__cell--media">             
                    <a href="#" className="prod-list__cell--media__link tooltip__container">

                      <img src="images/prod_thumb.jpg" align="" title="" className="prod-list__cell--media__img" />
                      <span className="tooltip tooltip--right tooltip--md prod-list__cell--media__tooltip"> 
                        <img src="images/prod_thumb_lg.png" align="" title="" className="img--responsive prod-list__cell--media__thumb" />
                      </span>

                    </a>
                  </div>
                  <div className="prod-list__cell prod-list__cell--desc"> 
                    <h5 className="prod-list__cell--title text_color--bold">Special Testimonial Layout </h5>
                    <p className="prod-list__cell--copy">by: Tom_John</p>
                  </div>
                </li>
              </ul>
              
            </div>
            
          </div>
          <div className="form__row clearfix">
            <div className="form__cell">
              <p>You can either remove these dependencies from your package, or contact the 3rd party about publishing them or sharing them directly with <a href="#">legutierr</a>.</p>
            </div>
          </div>
          <div className="buttons clearfix">
            <button className="btn__lg bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
            <button className="btn__lg bg-dark" onClick = {this.handleCloseClick}>Share &amp; Transfer</button>
          </div>
        </div>
      </div>
      </div>
      )
  }
})

export {TransferWarningDependenciesPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/TransferWarningDependenciesPopup.jsx
 **/